import { render } from "./PricingTableField.vue?vue&type=template&id=32335b05"
import script from "./PricingTableField.vue?vue&type=script&lang=js"
export * from "./PricingTableField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__